
import React from 'react';
import { Theme } from '../types';
import { CloseIcon, AlertTriangleIcon } from './icons';

interface AlertDisplayProps {
  warnings: string[];
  onClose: () => void;
  theme: Theme;
}

const AlertDisplay: React.FC<AlertDisplayProps> = ({ warnings, onClose, theme }) => {
  if (warnings.length === 0) {
    return null;
  }

  // Estilos modificados para parecer un "globo flotante"
  const bgColor = theme === 'dark' ? 'bg-red-600' : 'bg-red-500';
  const textColor = 'text-white';
  
  return (
    <div
      className={`fixed bottom-8 right-8 max-w-sm p-4 rounded-2xl shadow-2xl ${bgColor} z-50 animate-bounce-in flex items-start gap-3 border-2 border-white/20`}
      role="alert"
      aria-live="assertive"
    >
      <div className="bg-white/20 p-2 rounded-full flex-shrink-0">
        <AlertTriangleIcon className="w-6 h-6 text-white" />
      </div>
      
      <div className="flex-grow">
        <h3 className="font-bold text-white mb-1 text-sm uppercase tracking-wide">Atención</h3>
        <ul className={`list-disc list-inside space-y-1 ${textColor} text-sm`}>
          {warnings.map((warning, index) => (
            <li key={index} className="leading-tight">{warning}</li>
          ))}
        </ul>
      </div>

      <button
        onClick={onClose}
        className="text-white/70 hover:text-white transition-colors"
        aria-label="Cerrar advertencias"
      >
        <CloseIcon className="w-5 h-5" />
      </button>
    </div>
  );
};

export default AlertDisplay;
